// Delegates analytics clicks so tracked elements added after page load are included.
export function initializeAnalyticsTracking(on, createAnalyticsGroup, selector, getCurrentPage) {
  return on('click', selector, (_event, element) => {
    const trackingGroup = element.getAttribute('data-tracking-group')
    const trackingLabel = element.getAttribute('data-tracking-label')

    if (!trackingGroup || !trackingLabel) return

    const track = createAnalyticsGroup(trackingGroup)
    track('click', `${trackingLabel} from ${getCurrentPage()}`)
  })
}
